import React, { ReactNode } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ROUTES } from "~/const/route";
import {
  Drawer,
  Toolbar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
// import HomeIcon from "@material-ui/icons/Home";
import PeopleIcon from "@material-ui/icons/People";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import NotificationsIcon from "@material-ui/icons/Notifications";
import HelpIcon from "@material-ui/icons/Help";

type RouteProps = {
  name: string;
  path: string;
  icon: ReactNode;
};

const SidebarContent: React.VFC = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const classes = makeStyles({
    drawerContainer: {
      overflow: "auto",
    },
  })();
  const routes: RouteProps[] = [
    // {
    //   name: "ホーム",
    //   path: ROUTES.ADMIN.HOME,
    //   icon: <HomeIcon />,
    // },
    {
      name: "専門家",
      path: ROUTES.ADMIN.SPECIALIST,
      icon: <PeopleIcon />,
    },
    {
      name: "会話パターン",
      path: ROUTES.ADMIN.PATTERN,
      icon: <QuestionAnswerIcon />,
    },
    {
      name: "通知",
      path: ROUTES.ADMIN.NOTIFICATION,
      icon: <NotificationsIcon />,
    },
    {
      name: "ヘルプ",
      path: ROUTES.ADMIN.HELP,
      icon: <HelpIcon />,
    },
  ];
  return (
    <div className={classes.drawerContainer}>
      <List>
        {routes.map((route) => {
          return (
            <ListItem
              key={`route_${route.path}`}
              button
              selected={pathname === route.path}
              onClick={() => history.push(route.path)}
            >
              <ListItemIcon>{route.icon}</ListItemIcon>
              <ListItemText primary={route.name} />
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

type Props = {
  open?: boolean;
  onClose?: () => void;
  width: number;
};

export const Sidebar: React.VFC<Props> = (props) => {
  const drawerWidth = props.width;
  const classes = makeStyles({
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
  })();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!isMobile) {
    return (
      <Drawer
        className={classes.drawer}
        variant="permanent"
        anchor="left"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar />
        <SidebarContent />
      </Drawer>
    );
  } else {
    return (
      <Drawer
        className={classes.drawer}
        variant="temporary"
        anchor="left"
        open={props.open}
        onClose={props.onClose}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Toolbar />
        <SidebarContent />
      </Drawer>
    );
  }
};
